/**
 * Validates if a string is a data URL with an image MIME type.
 * @example
 * isDataImage("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA");
 * // true
 * isDataImage("data:text/plain;base64,SGVsbG8=");
 * // false
 */
export const isDataImage = (str: string): boolean => /^\s*data:image\/[a-z0-9+-]+(?:;[a-z-]+=[a-z0-9-]+)?(?:;base64)?,/i.test(str);
